function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
function checkCookie() {
  let currentCollection = getCookie('currentCollection');
  if (
    window.location.pathname.includes('collections') &&
    !window.location.pathname.includes('products')
  ) {
    currentCollection = window.location.href;
    setCookie('currentCollection', currentCollection, 1);
    setInterval(function () {
      let updatedURL = window.location.href;
      if (currentCollection !== updatedURL) {
        currentCollection = updatedURL;
        setCookie('currentCollection', currentCollection, 1);
      }
    }, 200);
  }
  if (window.location.pathname.includes('cart')) {
    const target = document.querySelector('#shopify-section-cart-template');
    const observer = new MutationObserver(function () {
      if (target.querySelector('.continue-shopping')) {
        observer.disconnect();
        console.log(currentCollection);
        document
          .querySelector('.continue-shopping')
          .setAttribute('href', currentCollection);
      }
    });
    observer.observe(target, { subtree: true, childList: true });
  }
}
checkCookie();
